import { render, staticRenderFns } from "./ImageWrapper.vue?vue&type=template&id=eb38766a&scoped=true"
import script from "./ImageWrapper.vue?vue&type=script&lang=js"
export * from "./ImageWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb38766a",
  null
  
)

export default component.exports